'use client';

import PropTypes from 'prop-types';
import {capitalizeFirstLetter} from "@/utils/strings.ts";

import {Chip} from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";


const splitIngredientsIntoGroups = (ingredients) => {
  const ingredientsInGroups = {};

  ingredients.forEach(ingredient => {
    const ingredientGroupId = ingredient.groupId;
    if (ingredientGroupId in ingredientsInGroups) {
      ingredientsInGroups[ingredientGroupId].list.push(ingredient);
    } else {
      ingredientsInGroups[ingredientGroupId] = {
        label: ingredient.groupName,
        list: [ingredient]
      };
    }
  });

  return ingredientsInGroups;
}

function RecipeIngredientList({recipeData}) {
  if (!recipeData.ingredients || recipeData.ingredients.length < 1) {
    return '';
  }

  const ingredientsInGroups = splitIngredientsIntoGroups(recipeData.ingredients);

  return (
    <Stack spacing={2}>
        <Typography variant="h6">Składniki</Typography>

        <Box
          rowGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
          }}
        >
          {Object.keys(ingredientsInGroups).map((ingredientGroupKey, idx) => (
              <Stack key={`${idx}-${ingredientGroupKey}`} spacing={1} direction="column">
                <Typography variant="subtitle1">{ingredientsInGroups[ingredientGroupKey].label}</Typography>
                {
                  ingredientsInGroups[ingredientGroupKey].list.map((ingredient, ingredientIdx) => (
                    <Stack
                      key={`${ingredientIdx}-${ingredient.code}`}
                      spacing={1}
                      direction="row"
                      alignItems="center"
                    >
                      <Chip variant="soft" color="primary" size="small" label={`${ingredient.quantity} ${ingredient.unitAbbreviation ?? ''}`} />
                      {capitalizeFirstLetter(ingredient.nameInRecipe ?? ingredient.name)}
                    </Stack>
                  ))
                }
              </Stack>
            )
          )}
        </Box>
      </Stack>
  );
}

RecipeIngredientList.propTypes = {
  recipeData: PropTypes.object
};

export default RecipeIngredientList;
